// src/stores/useLanguageStore.ts
import { create } from 'zustand';

export type Lang = 'en' | 'ge';

interface LanguageState {
  lang: Lang;
  toggle: () => void;
  setLang: (l: Lang) => void;
}

export const useLanguageStore = create<LanguageState>()((set, get) => ({
  lang: 'en',
  toggle: () => set({ lang: get().lang === 'en' ? 'ge' : 'en' }),
  setLang: (l) => set({ lang: l }),
}));